// extracted by mini-css-extract-plugin
export default {"Caption":"CarouselList_Caption__-aQq8"};